module.exports =
  '_GROUP_INFORMATION':
    'TITLE': "Group"
    'EDIT_GROUP': 'グループ情報を編集'
    'NUM_MEMBERS': 'メンバー({0})'
    'EDIT_MEMBER': 'メンバー編集'
    'EVENT': 'イベント'
    'LEAVE_GROUP': 'グループを退会'
    'RECENT_EVENTS': '最近のイベント'
    'GROUP_ADMIN': '管理者'
    'GROUP_ADMIN_SMALL': '管理者'
    'ALL_MEMBERS': 'メンバー全員を見る'
    'ALL_EVENTS': 'イベント一覧を見る'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-info/i18n/ja.coffee